import * as React from 'react';
import {withStyles} from "@material-ui/core";
import {GuideStyles} from "@components/guide/guide.styles";
import {WithStyles} from "@material-ui/core/styles";
import TranslateNew from "@translate/TranslateNew";

const tn: TranslateNew = TranslateNew.getInstance();

interface ITemplateCalendarProps extends WithStyles<typeof GuideStyles> {
    days: boolean[];
    primaryColor?: string;
    secondaryColor?: string;
    classes: any;
    monthView?: boolean | undefined;
    showDayNames?: boolean | undefined;
    onDayClick?: (day: number) => void | undefined;
    size?: 'small' | 'large';
    localization: 'en'|'se';
}

class TemplateCalendar extends React.Component<ITemplateCalendarProps> {

    constructor(props: any) {
        super(props);
    }

    public render() {
        const {
            classes: style, 
            days,
            primaryColor,
            secondaryColor,
            monthView,
            showDayNames,
            size,
            onDayClick,
            localization
        } = this.props;
        let calendar: boolean[] = [];

        let daysFixed:boolean[] =  days;

        if (localization === "en" && days.length > 0) {
            daysFixed =  [
                days[days.length - 1], 
                ...days.slice(0, days.length - 1)
            ]
        } else {
            daysFixed =  days;
        }

        if (monthView) {
            if (daysFixed.length) {
                calendar = [...daysFixed, ...daysFixed];
                const firstThreeElements = calendar.splice(0, 3);
                calendar = calendar.concat(firstThreeElements);
                const firstTwoElements = calendar.slice(0, 2);
                calendar = calendar.concat(firstTwoElements);
            } else {
                // For random generated squares for custom calendar views
                // calendar = Array.from({ length: 30 }, () => Math.random() < 0.5);
                calendar = Array(30).fill(true);
            }
        } else {
            calendar = daysFixed;
        }

        return (
            <div className={style.templateCalendar}>
                {showDayNames && (
                    <>
                        {this.props.localization === "en" && <div className={style.templateCalendarDayName}>{tn.lang.sun}</div>}
                        <div className={style.templateCalendarDayName}>{tn.lang.mon}</div>
                        <div className={style.templateCalendarDayName}>{tn.lang.tue}</div>
                        <div className={style.templateCalendarDayName}>{tn.lang.wed}</div>
                        <div className={style.templateCalendarDayName}>{tn.lang.thu}</div>
                        <div className={style.templateCalendarDayName}>{tn.lang.fri}</div>
                        <div className={style.templateCalendarDayName}>{tn.lang.sat}</div>
                        {this.props.localization === "se" && <div className={style.templateCalendarDayName}>{tn.lang.sun}</div>}
                    </>
                )}
                {monthView && (<>
                    <div className={style.templateCalendarDay}/>
                    <div className={style.templateCalendarDay}/>
                    <div className={style.templateCalendarDay}/>
                </>)}
                {calendar.map((day, dayIndex) => (
                    <div
                        key={`${dayIndex}-${day}`}
                        className={size === 'large' ? style.templateCalendarDayLarge : style.templateCalendarDay}
                        style={{backgroundColor: day ? primaryColor : secondaryColor, cursor: onDayClick ? 'pointer' : 'default'}}
                        onClick={(event) => onDayClick ? onDayClick(dayIndex) : undefined}
                    />
                ))}
            </div>
        );
    }
}

export default withStyles(GuideStyles)(TemplateCalendar);



// WEBPACK FOOTER //
// ./src/components/guide/components/templateCalendar.component.tsx